import React from 'react';
import { SxStyle } from '../../types';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const styles: SxStyle = {
  details: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
  },
  title: {
    fontSize: '1.1rem',
    letterSpacing: '0.5px',
    paddingLeft: '15px',
  },
  heading: {
    paddingRight: '15px',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
  },
};

interface Props extends AccordionProps {}

function AccordionWrapper({ children, title, ...props }: Props) {
  return (
    <Accordion variant="outlined" {...props}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} id={title} sx={styles.heading}>
        <Typography variant="h6" sx={styles.title}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.details}>{children}</AccordionDetails>
    </Accordion>
  );
}

export default AccordionWrapper;
